import React from "react";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Input from "components/bootstrap/Input";
class QueryTitleEditModal extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.open = (activeQueryTitle) => {
      this.setState({
        titleDraft: activeQueryTitle,
        showModal: true
      });
    };
    this.close = () => {
      this.setState({ showModal: false });
    };
    this._onDraftSave = () => {
      const { titleDraft } = this.state;
      const { onTitleChange } = this.props;
      onTitleChange(titleDraft);
      this.close();
    };
    this._onDraftChange = (evt) => {
      this.setState({ titleDraft: evt.target.value });
    };
    this.state = {
      showModal: false,
      titleDraft: ""
    };
  }
  render() {
    const { titleDraft, showModal } = this.state;
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: showModal,
        title: "Editing dashboard page title",
        onSubmitForm: this._onDraftSave,
        onCancel: this.close,
        submitButtonText: "Update title",
        bsSize: "large"
      },
      /* @__PURE__ */ React.createElement(
        Input,
        {
          autoFocus: true,
          help: "Enter a helpful dashboard page title. It has a maximum length of 40 characters.",
          id: "title",
          label: "Title",
          name: "title",
          onChange: this._onDraftChange,
          maxLength: 40,
          required: true,
          type: "text",
          value: titleDraft
        }
      )
    );
  }
}
export default QueryTitleEditModal;
